var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"la-ball-clip-rotate-pulse la-2x"},[_c('div'),_c('div')])])
}]

export { render, staticRenderFns }